import React from "react";
import { Card, CardContent, CardHeader, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import {
  EntityHasSystemsCard,
  EntityLayout,
  EntityLinksCard,
  AboutField,
  RelatedEntitiesCard,
} from '@backstage/plugin-catalog';
import { MarkdownContent, Link } from "@backstage/core-components";
import { EaPackDomainEntityV1beta1, EaPackGroupEntityV1beta1 } from "@internal/plugin-ea-pack-common";
import { UserAndTitleField } from "../UserCard";
import { EntityTable, useEntity } from "@backstage/plugin-catalog-react";
import { Entity, GroupEntity, RELATION_HAS_PART, RELATION_PART_OF } from "@backstage/catalog-model";
import ListAltIcon from '@material-ui/icons/ListAlt';

export const SubDomainEntityLayout = (props: { children?: React.ReactNode, gemcheckCard?: React.ReactNode }) => {
  const entity = useEntity().entity as EaPackDomainEntityV1beta1;
  const roles = entity.spec.roles;
  const jiraProjectKey = entity.metadata.annotations?.["jira/project-key"]

  return (
    <EntityLayout parentEntityRelations={["partOf"]}>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item md={6}>
            <Card >
              <CardHeader
                title="About"
                action={<>
                  <IconButton
                    component={Link}
                    aria-label="Jira"
                    disabled={jiraProjectKey === undefined}
                    title={"Jira Dashboard"}
                    to={`https://pandoradigital.atlassian.net/browse/${encodeURIComponent(jiraProjectKey!)}`}
                  >
                    <ListAltIcon />
                  </IconButton>
                </>
                }
              />
              <Divider />
              <CardContent >
                <Grid container>
                  <Grid item xs={12}>
                    <AboutField label="Description">
                      <MarkdownContent
                        content={entity?.metadata?.description || 'No description'}
                      />
                    </AboutField>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6}>
            <Grid container spacing={3}>
              <Grid item md={12}>
                <Card >
                  <CardHeader title="The Team" />
                  <Divider />
                  <CardContent >
                    <Grid container>
                      <UserAndTitleField user={roles?.domainLead} title="Product" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      <UserAndTitleField user={roles?.deliveryLead} title="Delivery" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      <UserAndTitleField user={roles?.engineeringLead} title="Engineering" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      <UserAndTitleField user={roles?.agileCoach} title="Agile Coach" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      <UserAndTitleField user={roles?.solutionArchitect} title="Solution Architect" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12}>
                {props.gemcheckCard}
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item md={6}>
            <EntityLinksCard />
          </Grid> */}
          <Grid item md={12}>
            <EntityHasSystemsCard variant="gridItem" title="Products" />
          </Grid>
          <Grid item md={12}>
            <RelatedEntitiesCard
              variant="gridItem"
              title="Product Teams"
              entityKind={"Group"}
              relationType={RELATION_HAS_PART}
              columns={[
                EntityTable.columns.createEntityRefColumn({ defaultKind: "Group" }),
                EntityTable.columns.createEntityRelationColumn({ title: "Delivery", relation: "hasTeamManager", defaultKind: "user", filter: { kind: "user" } }),
                EntityTable.columns.createEntityRelationColumn({ title: "Product", relation: "hasProductManager", defaultKind: "user", filter: { kind: "user" } }),
                EntityTable.columns.createEntityRelationColumn({ title: "Engineering", relation: "hasLeadEngineer", defaultKind: "user", filter: { kind: "user" } }),
              ]}
              asRenderableEntities={(entities: Entity[]): EaPackGroupEntityV1beta1[] => entities as EaPackGroupEntityV1beta1[]}
              emptyMessage="No Product Teams for this Sub-Domain"
              emptyHelpLink={'#'}
            />
          </Grid>
        </Grid >
      </EntityLayout.Route >
      {props.children}
    </EntityLayout >
  );
};
